var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSafety = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.433 2.217a.85.85 0 0 1 1.134 0 11.1 11.1 0 0 0 8.008 2.824.85.85 0 0 1 .866.636c.267 1.033.409 2.115.409 3.229 0 5.988-4.096 11.018-9.638 12.445a.85.85 0 0 1-.424 0C6.246 19.924 2.15 14.894 2.15 8.906c0-1.114.142-2.197.41-3.23a.85.85 0 0 1 .865-.635q.285.015.575.015c2.856 0 5.46-1.073 7.433-2.84M4.057 6.755a11.2 11.2 0 0 0-.207 2.15c0 5.118 3.449 9.433 8.15 10.743 4.701-1.31 8.15-5.625 8.15-10.742q-.002-1.107-.207-2.15A12.8 12.8 0 0 1 12 3.962a12.8 12.8 0 0 1-7.943 2.793",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 11.65a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.383 9.58c-.125.31-.133.716-.133 1.07h-1.5v-.03c0-.324 0-.996.242-1.6.13-.326.346-.668.698-.926.359-.261.801-.394 1.31-.394s.951.133 1.31.394c.352.258.567.6.698.926.243.604.242 1.276.242 1.6v.03h-1.5c0-.354-.008-.76-.133-1.07a.6.6 0 0 0-.192-.274C12.36 9.259 12.24 9.2 12 9.2s-.361.06-.425.106a.6.6 0 0 0-.192.274",
  clipRule: "evenodd"
}))));
export default SvgSafety;